import React from 'react';
import {observer} from 'mobx-react';

import {StandingsWidgetTabs} from "./elements/standings-widget.tabs";
import {StandingsLegendButton} from "./legend/standings-widget.legend-button";
import {Loader} from "../../../core/components/loading/loader";
import {StandingsWidgetPlaceholder} from "./placeholders/standings-widget.placeholder";
import classNames from "classnames";
import styles from "../styles/standings-widget.module.scss";
import {StandingsWidgetSeeAllFooter} from "./elements/standings-widget.see-all-footer";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {StandingsWidgetLegendFooter} from "./legend/standings-widget.legend-footer";
import {StandingsWidgetTable} from "./table/standings-widget.table";
import {StandingsWidgetStages} from "./standings-widget.stages";
import {StandingsWidgetCompetitionsRules} from "./competition-rules/standings-widget-competitions-rules";
import {AD_DISPLAYS, COMPONENT_STATES, FETCHING_STATES} from "../../../core/consts";
import {StandingsWidgetPointsDeductions} from "./points-deductions/standings-widget.points-deductions";
import {ExternalAd} from "../../../core/components/ad/external-ad/external-ad";
import {StandingsWidgetGamesSuggestions} from "./standings-widget.games-suggestions";

export class StandingsWidgetContentProps extends BaseProps {}

export const StandingsWidgetContent = observer(({
                                                  source,
                                                  controller,
                                                  collapsedCompetitorIds,
                                                  isPreviewStandings
                                                }: StandingsWidgetContentProps) => {
  const {state, device:{isSmallView}} = controller;
  const {
    fetchingState,
    componentState,
    hasGroups,
    shouldRenderExternalAd,
    externalAdConfig
  } = state;

  const containerClassName: String = classNames(
    styles.content,
    {[styles.preview]: isPreviewStandings}
  );

  const loaderProps = {
    when: fetchingState === FETCHING_STATES.fetching || componentState === COMPONENT_STATES.loading,
    Component: StandingsWidgetPlaceholder,
    componentProps: {
      hideHeader: true,
      collapsedCompetitorIds,
      isPreviewStandings
    }
  }

  const tableProps = {
    source,
    controller,
    isPreviewStandings
  }

  const seeAllFooterProps = {
    source,
    controller,
    collapsedCompetitorIds,
  }

  const legendContentProps = {
    controller,
    className: classNames(hasGroups ? styles.legend_has_groups : styles.legend_container)
  }

  const pointDeductionsProps = {
    controller,
    isPreviewStandings
  }

  const externalAdProps = {
    isSmallView,
    isMock: state.appState.settings.config.adDisplay === AD_DISPLAYS.placeholders,
    className: classNames(styles.dba_banner),
    controller,
    config: externalAdConfig
  }

  return (
    <div className={containerClassName}>
      <StandingsWidgetStages controller={controller}/>
      <StandingsWidgetTabs controller={controller}/>
      <Loader {...loaderProps}>
        <StandingsWidgetTable {...tableProps}/>
        <StandingsWidgetSeeAllFooter {...seeAllFooterProps}/>
        <StandingsLegendButton controller={controller}/>
        <StandingsWidgetGamesSuggestions controller={controller} />
        {
          shouldRenderExternalAd ? <ExternalAd {...externalAdProps}/> : null
        }
        <StandingsWidgetLegendFooter {...legendContentProps}/>
        <StandingsWidgetPointsDeductions {...pointDeductionsProps}/>
        <StandingsWidgetCompetitionsRules controller={controller}/>
      </Loader>
    </div>
  )
});
